// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";
// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/**
 * Tahsilat raporunun özet kartlarını ve yaşlandırma dilimlerini getirir.
 * StartDate/EndDate yalnızca gerçekleşmiş tahsilatı,
 * OverdueStartDate/EndDate vadesi geçen açık alacakları,
 * UpcomingStartDate/EndDate gelecek vadeli açık alacakları etkiler.
 *
 * @param {{
 *   params?: object,
 *   query?: {
 *     StartDate?: string,
 *     EndDate?: string,
 *     OverdueStartDate?: string,
 *     OverdueEndDate?: string,
 *     UpcomingStartDate?: string,
 *     UpcomingEndDate?: string,
 *     CustomerId?: string,
 *     RegionId?: string,
 *     EmployeeId?: string,
 *     PaymentType?: 1 | 2 | 3 | 4,
 *   }
 * }} option
 */
export const GetSummary = async (option) => {
  const response = await $api.get(
    Endpoints.CollectionReport.GetSummary(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Tip bazlı açık alacak listesini (Type=Total iken gerçekleşmiş tahsilatları)
 * sayfalanmış getirir. PaymentType ile daraltılabilir.
 * StartDate/EndDate gerçekleşmiş tahsilat listesini,
 * OverdueStartDate/EndDate vadesi geçenleri,
 * UpcomingStartDate/EndDate gelecek vadeli açık alacakları filtreler.
 *
 * @param {{
 *   params?: object,
 *   query?: {
 *     StartDate?: string,
 *     EndDate?: string,
 *     OverdueStartDate?: string,
 *     OverdueEndDate?: string,
 *     UpcomingStartDate?: string,
 *     UpcomingEndDate?: string,
 *     CustomerId?: string,
 *     RegionId?: string,
 *     EmployeeId?: string,
 *     Type: 1 | 2 | 3 | 4 | 'Total',
 *     PaymentType?: 1 | 2 | 3 | 4,
 *     Page?: number,
 *     Limit?: number,
 *   }
 * }} option
 */
export const GetDetails = async (option) => {
  const response = await $api.get(
    Endpoints.CollectionReport.GetDetails(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetSummary,
  GetDetails,
};
